var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDafiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 26,
    viewBox: "0 0 80 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5318 0.992188C15.7729 0.992188 15.1577 1.58451 15.1577 2.31527V16.4072V8.38411C15.1577 8.38411 14.1718 7.75269 12.8603 7.33121C11.8809 7.01645 10.649 6.88001 9.89409 6.87999C4.44145 6.87999 0 11.1568 0 16.4072C0 21.6576 4.44145 25.9345 9.89409 25.9345C15.3467 25.9345 19.5904 21.6576 19.5904 16.4072V2.31527C19.5904 1.58451 18.9752 0.992188 18.2163 0.992188H16.5318ZM9.93243 11.1303C12.967 11.1303 15.138 13.4852 15.138 16.4072C15.138 17.771 14.6648 19.0117 13.8517 19.9465C12.9229 21.0148 11.5506 21.684 9.93243 21.684C6.89786 21.684 4.45236 19.3292 4.45233 16.4072C4.45233 13.4852 6.89786 11.1303 9.93243 11.1303Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89409 6.87988C4.44145 6.87988 0 11.1567 0 16.4071C0 21.6575 4.44145 25.9344 9.89409 25.9344C15.3467 25.9344 19.5904 21.6575 19.5904 16.4071H15.1577V8.384C15.0099 8.29067 14.9392 8.23936 14.7057 8.11561C13.2798 7.35978 11.66 6.87988 9.89409 6.87988ZM9.93243 11.1302C12.967 11.1302 15.138 13.4851 15.138 16.4071C15.138 17.7709 14.6648 19.0116 13.8517 19.9464C12.9229 21.0147 11.5506 21.6839 9.93243 21.6839C6.89786 21.6839 4.45236 19.3291 4.45233 16.4071C4.45233 13.4851 6.89789 11.1302 9.93243 11.1302Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.189 5.05469H36.5305C38.5239 5.05469 40.2858 5.42094 41.816 6.15341C43.3461 6.88591 44.5351 7.9173 45.3832 9.24755C46.2313 10.5778 46.6557 12.127 46.6557 13.8951C46.6557 15.6632 46.2313 17.2123 45.3832 18.5426C44.5351 19.873 43.3461 20.9041 41.816 21.6366C40.2858 22.3691 38.5239 22.7353 36.5305 22.7353H28.189V5.05469ZM36.3204 19.3761C38.1568 19.3761 39.6213 18.8836 40.7141 17.8986C41.8072 16.9134 42.3536 15.579 42.3536 13.8951C42.3536 12.2112 41.8072 10.8767 40.7141 9.89165C39.6213 8.90658 38.1568 8.41402 36.3204 8.41402H32.4382V19.3761H36.3204Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1046 9.14641V22.7352H59.1962V21.1692C58.182 22.3481 56.713 22.9375 54.7893 22.9375C53.4605 22.9375 52.2582 22.6511 51.1826 22.0788C50.1072 21.5062 49.2633 20.6895 48.6515 19.6285C48.0394 18.5678 47.7332 17.3384 47.7332 15.9409C47.7332 14.5433 48.0394 13.314 48.6515 12.2532C49.2633 11.1923 50.1072 10.3756 51.1826 9.80311C52.2582 9.2306 53.4605 8.94434 54.7893 8.94434C56.5907 8.94434 57.9985 9.49159 59.0127 10.5861V9.14641H63.1046ZM55.4975 19.7042C56.5295 19.7042 57.3864 19.3632 58.0684 18.6815C58.7501 17.9995 59.0913 17.0859 59.0913 15.9409C59.0913 14.7958 58.7501 13.8823 58.0684 13.2004C57.3864 12.5184 56.5295 12.1774 55.4975 12.1774C54.4484 12.1774 53.5828 12.5184 52.9008 13.2004C52.2187 13.8823 51.8779 14.7958 51.8779 15.9409C51.8779 17.0859 52.2187 17.9995 52.9008 18.6815C53.5828 19.3632 54.4484 19.7042 55.4975 19.7042Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0662 9.45083L78.185 9.45092L77.9972 12.4818L69.1711 12.4818V22.7365H65.0791V8.84463C65.0791 7.29544 65.5556 6.06621 66.5086 5.15692C67.4619 4.24762 68.804 3.79297 70.5351 3.79297C71.1473 3.79297 71.7286 3.85612 72.2796 3.98242C72.8302 4.10869 73.2895 4.28973 73.6566 4.52547L72.5813 7.37963C72.109 7.0597 71.5581 6.89974 70.9288 6.89974C69.687 6.89974 69.0662 7.55646 69.0662 8.86988V9.45083Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4094 9.45117H79.5017V22.7358H75.4094V9.45117Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4555 7.25236C76.7035 7.25236 76.0914 7.04187 75.6194 6.62088C75.1471 6.19993 74.9111 5.67792 74.9111 5.05489C74.9111 4.43183 75.1471 3.90985 75.6194 3.48887C76.0914 3.06788 76.7035 2.85742 77.4555 2.85742C78.2074 2.85742 78.8195 3.05947 79.2915 3.46362C79.7638 3.86774 79.9998 4.37292 79.9998 4.97912C79.9998 5.63581 79.7638 6.17886 79.2915 6.60826C78.8195 7.03766 78.2074 7.25236 77.4555 7.25236Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.7278,
    y1: 3.92493,
    x2: 2.74048,
    y2: 24.5641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525336,
    stopColor: "#00F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23FCCF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5548 7.92757) scale(19.4873 18.7647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606",
    stopOpacity: 0.476377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.110106,
    stopColor: "#030509",
    stopOpacity: 0.253808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45098,
    stopColor: "#00040C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659125,
    stopColor: "#144A4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AFDC5",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDafiLogo);
export default __webpack_public_path__ + "static/media/DafiLogo.1153a7f4d667536943612971ef17df5a.svg";
export { ForwardRef as ReactComponent };